module.exports = __webpack_public_path__ + "static/media/OFL.5da468cc.txt";